import { Stack } from "@mui/material";
import { DRMPProvider } from "./context";
import { useDRMP } from "./logics";
import { DRMPMonth } from "./month";
import { DRMPContainer, calendarClasses } from "./styles";
import { DRMPYear } from "./year";

export const DRPMonth = () => {
  const contextValues = useDRMP();
  return (
    <DRMPContainer className={calendarClasses.root}>
      <DRMPProvider {...contextValues}>
        <Stack
          direction="column"
          sx={{
            gap: 1,
          }}
        >
          <DRMPYear index="startDate" />
          <DRMPMonth index="startDate" />
        </Stack>
        <Stack
          direction="column"
          sx={{
            gap: 1,
          }}
        >
          <DRMPYear index="endDate" />
          <DRMPMonth index="endDate" />
        </Stack>
      </DRMPProvider>
    </DRMPContainer>
  );
};
